import {Col, Row} from "antd";
import {Button} from "@material-ui/core";
import AddIcon from '@material-ui/icons/Add';
import useCategoryModal from "../../../hooks/useCategoryModal";

export default function SubHeader() {

    const {handleOpen, CategoryModal} = useCategoryModal();

    return (
        <>
            <section className='mb-3'>
                <Row>
                    <Col>
                        <h5>Categories</h5>
                    </Col>
                    <Col className='ml-auto'>
                        <Button variant='contained' color='primary' onClick={handleOpen}>
                            <AddIcon/>
                            New
                        </Button>
                    </Col>
                </Row>
            </section>

            <CategoryModal/>
        </>
    )
}